// sm-mega-menu-live: hover-intent + click dropdowns for Shop/Science/About, ported
// from the live smoots-mega-nav.liquid behavior (openDrop/closeDrop/hover timers),
// rebuilt without jQuery. Triggers live in sm-header-live
// ([data-live-nav-trigger="shop|science|about"]).
import { on } from './sm-core.js';

const HASH_FORCE = 'sm-open-menu';

function root() {
  return document.querySelector('.sm-mega-menu-live');
}

function setTop() {
  const header = document.querySelector('.sm-header-live__bar');
  if (!header) return;
  document.documentElement.style.setProperty('--sm-live-nav-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
}

function dropdowns() {
  const map = {};
  document.querySelectorAll('[data-live-nav-dropdown]').forEach((el) => { map[el.getAttribute('data-live-nav-dropdown')] = el; });
  return map;
}

function triggers() {
  const map = {};
  document.querySelectorAll('[data-live-nav-trigger]').forEach((el) => { map[el.getAttribute('data-live-nav-trigger')] = el; });
  return map;
}

let openName = null;
let hoverTimer = 0;

function open(name) {
  const dd = dropdowns();
  const tt = triggers();
  if (!dd[name]) return;
  setTop();
  if (openName && openName !== name) {
    dd[openName].removeAttribute('data-active');
    tt[openName]?.setAttribute('aria-expanded', 'false');
  }
  dd[name].setAttribute('data-active', '');
  tt[name]?.setAttribute('aria-expanded', 'true');
  root()?.setAttribute('data-open', '');
  openName = name;
}

function close() {
  if (!openName) return;
  const dd = dropdowns();
  const tt = triggers();
  dd[openName]?.removeAttribute('data-active');
  tt[openName]?.setAttribute('aria-expanded', 'false');
  root()?.removeAttribute('data-open');
  openName = null;
}

Object.entries(triggers()).forEach(([name, trigger]) => {
  trigger.addEventListener('mouseenter', () => { clearTimeout(hoverTimer); open(name); });
  trigger.addEventListener('mouseleave', () => { hoverTimer = window.setTimeout(close, 160); });
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    openName === name ? close() : open(name);
  });
});

Object.values(dropdowns()).forEach((dd) => {
  dd.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
  dd.addEventListener('mouseleave', () => { hoverTimer = window.setTimeout(close, 160); });
});

document.addEventListener('click', (e) => {
  if (!openName) return;
  const nav = document.querySelector('.sm-header-live, .sm-mega-menu-live');
  if (nav && !nav.contains(e.target)) close();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && openName) {
    const name = openName;
    close();
    triggers()[name]?.focus();
  }
});

document.addEventListener('focusout', (e) => {
  if (!openName) return;
  requestAnimationFrame(() => {
    const active = document.activeElement;
    const nav = document.querySelector('.sm-header-live, .sm-mega-menu-live');
    if (!active || !nav || !nav.contains(active)) close();
  });
});

on('sm:cart:open', close);

// Shop tabs (collection / goal / help / stacks)
document.querySelectorAll('[data-live-nav-tab]').forEach((tab) => {
  const activate = () => {
    const key = tab.getAttribute('data-live-nav-tab');
    document.querySelectorAll('[data-live-nav-tab]').forEach((t) => t.classList.toggle('sm-mega-menu-live__tab--active', t === tab));
    document.querySelectorAll('[data-live-nav-panel]').forEach((p) => p.classList.toggle('sm-mega-menu-live__panel--active', p.getAttribute('data-live-nav-panel') === key));
  };
  tab.addEventListener('mouseenter', activate);
  tab.addEventListener('click', activate);
});

// theme editor: open only while this section is selected, close again when deselected
if (location.hash.includes(HASH_FORCE)) {
  open('shop');
}
document.addEventListener('shopify:section:select', (e) => {
  if (e.target.querySelector?.('[data-section="sm-mega-menu-live"]')) open('shop');
});
document.addEventListener('shopify:section:deselect', (e) => {
  if (e.target.querySelector?.('[data-section="sm-mega-menu-live"]')) close();
});
